import { uri } from '../utils/config';
import { HTTP } from './secure/http';

export const updateService = async (placeId, serviceId, update) => {
  if (!placeId || !serviceId || !update) {
    console.log('NO PLACE ID');
    return;
  }

  await HTTP.post({
    path: `${uri.api}/place/${placeId}/services/${serviceId}/update`,
    data: update,
  });
};